import { Injectable } from '@angular/core';
import { BaseService, E8HttpClient, C8HttpClientOptions } from '../../../../core';
import { DynamicComponentEditFormGetMetaInfoRequest, DynamicComponentEditFormGetMetaInfoResponse, DynamicComponentEditFormGetModelRequest, DynamicComponentEditFormGetModelResponse } from './model/models';
import { DynamicComponentEditFormAddRequest } from './model/dynamicComponentEditFormAddRequest';
import { DynamicComponentEditFormAddResponse } from './model/dynamicComponentEditFormAddResponse';
import { DynamicComponentEditFormUpdateRequest } from './model/dynamicComponentEditFormUpdateRequest';
import { DynamicComponentEditFormUpdateResponse } from './model/dynamicComponentEditFormUpdateResponse';
@Injectable()
export class DynamicComponentEditFormService extends BaseService {
  private getColsMetaInfo_URL = 'metabase/dynamicComponentEditForm/getMetaInfo';
  private add_URL = 'metabase/dynamicComponentEditForm/add';
  private update_URL = 'metabase/dynamicComponentEditForm/update';
  private getModel_URL = 'metabase/dynamicComponentEditForm/getModel';
  constructor(private client: E8HttpClient) {
    super();
  }
  getMetaInfo(request: DynamicComponentEditFormGetMetaInfoRequest, options?: C8HttpClientOptions): Promise<DynamicComponentEditFormGetMetaInfoResponse> {
    return this.client.post(this.fUrl(this.getColsMetaInfo_URL), request, options);
  }
  add(request: DynamicComponentEditFormAddRequest, options?: C8HttpClientOptions): Promise<DynamicComponentEditFormAddResponse> {
    return this.client.post(this.fUrl(this.add_URL), request, options);
  }
  update(request: DynamicComponentEditFormUpdateRequest, options?: C8HttpClientOptions): Promise<DynamicComponentEditFormUpdateResponse> {
    return this.client.post(this.fUrl(this.update_URL), request, options);
  }
  getModel(request: DynamicComponentEditFormGetModelRequest, options?: C8HttpClientOptions): Promise<DynamicComponentEditFormGetModelResponse> {
    return this.client.post(this.fUrl(this.getModel_URL), request, options);
  }
}
